import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
// import FieldSelect from '../fields/FieldSelect';
import FieldAddress from '../fields/FieldAddress';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import AccountAddressForm from '../AccountDetailForm/Address/AccountAddressForm';
import { axiosCreateAddress } from '../../actions/user/address';
import { handleAxiosErrors } from '../../_utils';
import Select, { components } from 'react-select';
import ReactLoading from 'react-loading';
const FORM_LABEL = {
    DeliveryAddressID: getTranslation('FIELD.DELIVERY_ADDRESS'),
};
const DropdownIndicator = (props) => {
    const { indicatorText } = props.selectProps;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {indicatorText}
            </components.DropdownIndicator>
        )
    );
};

const Option = (props) => {
    const { data } = props;
    let { className } = props;

    if (typeof data.className != 'undefined') {
        className += ' ' + data.className;
    }

    return (
        components.Option && (
            <components.Option {...props} className={className} />
        )
    );
};

const getAddressGroupItemsDropdown = (list) => {
    return list.map((item) => {
        return {
            label: item.FullAddress,
            value: Number(item.ID),
        };
    });
};

function DeliveryAddressSection(props) {
    const {
        fieldRefs,
        handleFormUpdate,
        updateField,
        memberType,
        isLoading,
        handleFormDeliveryAddressLabel,
        handleFormUpdateBillingAddress,
        handleFormInputValue,
        formData,
        userAddresses,
        supplierAddresses,
        requestUserInfo,
        requestSupplierAddresses,
    } = props;
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [showAddForm, setShowAddForm] = useState(false);
    const [offset, setOffset] = useState(0); // Initial offset
    const [limit, setLimit] = useState(5); // Initial limit
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // New state to manage dropdown
    console.log('userAddresses', userAddresses);

    // Effects
    // --------------------

    // Functions
    // --------------------
    const getDeliveryAddressDropdown = () => {
        let list = [
            {
                label: getTranslation('FIELD.PLACEHOLDER.SELECT_ADDRESS'),
                value: '',
            },
        ];

        if (typeof userAddresses != 'undefined' && userAddresses.length) {
            list = [
                ...list,
                {
                    label: getTranslation('FIELD.GROUP.USER_ADDRESSES'),
                    options: getAddressGroupItemsDropdown(userAddresses),
                },
            ];

            // list = [...list, ...getAddressGroupItemsDropdown(userAddresses)];
        }

        if (
            typeof supplierAddresses != 'undefined' &&
            supplierAddresses.length &&
            memberType == 'retail-customer' && 0
        ) {
            list = [
                ...list,
                {
                    label:
                        memberType == 'retail-customer'
                            ? getTranslation('FIELD.GROUP.RESELLER_ADDRESSES')
                            : getTranslation(
                                  'FIELD.GROUP.WHOLESALER_ADDRESSES'
                              ),
                    options: getAddressGroupItemsDropdown(supplierAddresses),
                },
            ];

            // list = [...list, ...getAddressGroupItemsDropdown(supplierAddresses)];
        }

        return list;
    };

    /**
     * Create a new address
     *
     * @param formData
     * @param callback
     */

    const handleAddNewAddress = (formData, callback) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosCreateAddress(formData)
            .then((response) => {
                // requestSupplierAddresses(formData.ParentID);
                requestUserInfo();
                if (
                    typeof response.data.data.createDeliveryAddress !=
                    'undefined'
                ) {
                    const newAddressID =
                        response.data.data.createDeliveryAddress.ID;
                    const newAddressLabel =
                        response.data.data.createDeliveryAddress.FullAddress;
                    updateField('DeliveryAddressID', newAddressID);
                    setSelectedValue(
                        response.data.data.createDeliveryAddress.FullAddress
                    );
                    
                    handleFormDeliveryAddressLabel(
                        'DeliveryAddressLabel',
                        response.data.data.createDeliveryAddress.FullAddress
                    );
                    // var newlyaddID = findBusinessNameById(newAddressID);
                }

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };

    /**
     * Hide the add new address form
     *
     * @param formData
     * @param callback
     */
    const displayAddForm = () => {
        setShowAddForm(true);
    };

    /**
     * Hide the add new address form
     *
     * @param formData
     * @param callback
     */
    const closeAddForm = () => {
        setShowAddForm(false);
    };
    const debounce = (func, wait) => {
        let timeout;
        return function(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };
    const handleDebouncedInputChange = debounce((value) => {
        setInputValue(value);
        handleFormInputValue('inputValue', value);
        handleInputChange(value);
        if (value) {
            setIsDropdownOpen(true);
        } else {
            setIsDropdownOpen(false);
        }
    }, 1000);

    // handle input change event
    const handleInputChange = (value) => {
        requestUserInfo(0, 5, value).then((results) => {
            setIsDropdownOpen(true);
            console.log('results', results);
        });
    };

    const loadUserOptions = async (inputValue) => {
        setLimit((prevLimit) => prevLimit + 5);
        const response = await requestUserInfo(0, 5, inputValue);
        console.log('responserequest', response);
        return response.map((user) => ({
            label: user.name,
            value: user.id,
        }));
    };
    const findOptionLabelById = (id, options) => {
        let selectedOption = null;
        console.log('options==', options, id);
        for (const option of options) {
            if (option.options) {
                selectedOption = option.options.find((opt) => opt.value === id);
            } else {
                if (option.value === id) {
                    selectedOption = option;
                }
            }

            if (selectedOption) break;
        }

        return selectedOption;
    };

    const findBusinessNameById = (id) => {
        const numericId = Number(id);
        const business = userAddresses.find(
            (business) => business.ID == numericId
        );
        return business ? business.FullAddress : 'Select...';
    };

    // const handleMenuScrollToBottom = () => {
    //     // console.log('Scroll to bottom', props);
    //     // setOffset((prevOffset) => prevOffset + 1);
    //     // setLimit((prevLimit) => prevLimit + 8);
    //     // requestUserInfo(offset, limit); // Example: You need to adjust these functions to accept and use offset/limit
    //     // requestSupplierAddresses(formData.ParentID, offset, limit); // Same here
    // };
    const IndicatorsContainer = (props) => {
        const { limit, value, isMulti } = props.selectProps;

        if (isMulti && typeof value == 'Array' && value.length >= limit)
            return null;
        return (
            <components.IndicatorsContainer
                onClick={findBusinessNameById('')}
                {...props}
            />
        );
    };
    const selectedInputValue = findBusinessNameById(formData.DeliveryAddressID);
    const renderLoading = () => {
        if (!isLoading.deliveryAddress) return null;
        return (
            <ReactLoading
                type='spin'
                color='black'
                height={20}
                width={20}
                className='button__spinner'
            />
        );
    };
    return (
        <React.Fragment>
            <div className='select-delivery-supplier-modal__section'>
                {console.log('selectedValuen==', selectedInputValue)}
                <div className='row'>
                    <div className='col-xs-12 col-sm-6'>
                        <div className='select-delivery-supplier-modal__info'>
                            <h4 className='heading heading--h4'>
                                <LocalizedMessage
                                    id={
                                        'SELECT_DELIVERY_SUPPLIER_MODAL.DELIVERY_ADDRESS_HEADING'
                                    }
                                />
                            </h4>
                            <div className='text-box text-box--small text-box--grey'>
                                <p>
                                    <LocalizedMessage
                                        id={
                                            'SELECT_DELIVERY_SUPPLIER_MODAL.DELIVERY_ADDRESS_DESCRIPTION'
                                        }
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-6'>
                        <div className='select-delivery-supplier-modal__fields sss'>
                            <div className='field field--filled'>
                                <Select
                                    required
                                    ref={(r) =>
                                        (fieldRefs.DeliveryAddressID = r)
                                    }
                                    fieldClasses='field__input'
                                    className='react-select__container'
                                    classNamePrefix='react-select'
                                    isMulti={false}
                                    isSearchable={true}
                                    isClearable={true}
                                    limit={1}
                                    // end custom props
                                    components={{
                                        IndicatorsContainer,
                                        DropdownIndicator,
                                        Option,
                                    }}
                                    indicatorText={''}
                                    onInputChange={(value, actionMeta) => {
                                      
                                        if (
                                            actionMeta.action === 'input-change'
                                        ) {
                                            handleDebouncedInputChange(value);
                                        } else {
                                            console.log(
                                                'handleDebouncedInputChange===yahan aya',
                                                actionMeta
                                            );
                                            handleFormDeliveryAddressLabel(
                                                'DeliveryAddressLabel',
                                                ''
                                            );
                                        }
                                    }}
                                    onMenuOpen={() =>
                                        console.log('Menu is open')
                                    }
                                    onMenuClose={() =>
                                        console.log('Menu is close')
                                    }
                                    isLoading={isLoading.deliveryAddress}
                                    label={FORM_LABEL['DeliveryAddressID']}
                                    animatedLabel={
                                        FORM_LABEL['DeliveryAddressID']
                                    }
                                    name='DeliveryAddressID'
                                    options={getDeliveryAddressDropdown()}
                                    defaultValue={{
                                        label:
                                            selectedInputValue ||
                                            formData.DeliveryAddressLabel,
                                        value:
                                            selectedInputValue ||
                                            formData.DeliveryAddressLabel,
                                    }}
                                    value={{
                                        label:
                                            selectedInputValue ||
                                            formData.DeliveryAddressLabel,
                                    }}
                                    // placeholder={selectedInputValue || formData.DeliveryAddressLabel || 'Delivery Address'}
                                    onChange={(name, value) => {
                                        if (value.action == 'clear') {
                                            handleFormUpdateBillingAddress(
                                                value.name,
                                                ''
                                            );
                                            requestUserInfo()
                                        } else {
                                            handleFormUpdateBillingAddress(
                                                name,
                                                value
                                            );
                                        }
                                    }}
                                />
                                {renderLoading()}
                            </div>
                            <button
                                type='button'
                                className={classnames(
                                    'button-link-plain button-link-plain--small button-link-plain--main',
                                    showAddForm === true && 'hidden'
                                )}
                                onClick={displayAddForm}
                            >
                                <LocalizedMessage
                                    id={
                                        'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_DELIVERY_ADDRESS'
                                    }
                                />
                            </button>

                            <div
                                className={classnames(
                                    'select-delivery-supplier-modal__new-form',
                                    showAddForm === false && 'hidden'
                                )}
                            >
                                <AccountAddressForm
                                    handleFormSubmission={handleAddNewAddress}
                                    closeForm={closeAddForm}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

// default props
DeliveryAddressSection.defaultProps = {
    fieldRefs: null,
    updateField: () => {},
    handleFormUpdate: () => {},
    formData: {},
    isLoading: {},
    addresses: [],
};
// validate props
DeliveryAddressSection.propTypes = {
    fieldRefs: PropTypes.any.isRequired,
    updateField: PropTypes.func.isRequired,
    handleFormUpdate: PropTypes.func.isRequired,
    formData: PropTypes.any.isRequired,
    isLoading: PropTypes.any.isRequired,
    addresses: PropTypes.any.isRequired,
};

export default DeliveryAddressSection;
